"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegistryElement = exports.useStyleableAttributes = exports.styleToVEVars = void 0;
var react_1 = __importStar(require("react"));
var slate_react_1 = require("slate-react");
var EditorWidgetRegistry_1 = require("../WidgetRegistry/EditorWidgetRegistry");
var WidgetToolbar_1 = require("./WidgetToolbar");
var SelectionRing_1 = require("./SelectionRing");
var mobx_react_1 = require("mobx-react");
var inversify_react_1 = require("inversify-react");
var dynamic_1 = require("@vanilla-extract/dynamic");
var Resizer_1 = require("./Resizer");
var styles = __importStar(require("./RegistryElement.css"));
var slate_1 = require("slate");
var MaybeWrap_1 = __importDefault(require("@CommonFrontend/Utils/MaybeWrap"));
var classnames_1 = __importDefault(require("classnames"));
var tiny_invariant_1 = __importDefault(require("tiny-invariant"));
var GetTraitConfig_1 = require("@CommonFrontend/WidgetRegistry/Utils/GetTraitConfig");
var HasTrait_1 = require("@CommonFrontend/WidgetRegistry/Utils/HasTrait");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var widgetStyle_1 = require("Utils/widgetStyle");
var DragContext_1 = require("./DragContext");
var fontSizeMapping_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/BlockConfig/fontSizeMapping");
var lodash_1 = require("lodash");
var FilterableColorProvider_1 = require("../Styling/FilterableColorProvider");
function styleToVEVars(rawStyleObject, styleableConfig) {
    var e_1, _a;
    var _b, _c, _d;
    var style = {};
    var _loop_1 = function (property) {
        if (property.type === "color" && property.variable) {
            var rawColor = (0, lodash_1.get)(rawStyleObject, property.path);
            style[property.variable] = rawColor.abs;
        }
        if (property.type === "enumerable") {
            var selectedEnum_1 = (0, lodash_1.get)(rawStyleObject, property.path);
            var stylesToApply = property.options.find(function (option) { return option.value === selectedEnum_1; });
            if (stylesToApply) {
                (_b = stylesToApply.applies) === null || _b === void 0 ? void 0 : _b.forEach(function (_a) {
                    var variable = _a.variable, value = _a.value;
                    style[variable] = value;
                });
            }
        }
        if (property.type === "numerical" && property.variable) {
            style[property.variable] = "".concat((0, lodash_1.get)(rawStyleObject, property.path)).concat((_c = property.suffix) !== null && _c !== void 0 ? _c : "");
        }
        if (property.type === "alignable" && property.variable) {
            style[property.variable] = (0, lodash_1.get)(rawStyleObject, property.path);
        }
        if (property.type === "textLabel" && property.variable) {
            style[property.variable] = "\"".concat((0, lodash_1.get)(rawStyleObject, property.path), "\"");
        }
        if (property.type === "fontSize" && property.variable) {
            if ((_d = (0, lodash_1.get)(rawStyleObject, property.path)) === null || _d === void 0 ? void 0 : _d.themeRef) {
                style[property.variable] =
                    fontSizeMapping_1.fontSizeMappings[styleableConfig.styleKey][(0, lodash_1.get)(rawStyleObject, property.path).themeRef];
            }
            else {
                style[property.variable] = (0, lodash_1.get)(rawStyleObject, property.path).abs;
            }
        }
    };
    try {
        for (var _e = __values(styleableConfig.properties), _f = _e.next(); !_f.done; _f = _e.next()) {
            var property = _f.value;
            _loop_1(property);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return { style: (0, dynamic_1.assignInlineVars)(style) };
}
exports.styleToVEVars = styleToVEVars;
var useStyleableAttributes = function (element) {
    var _a;
    var blockStore = (0, inversify_react_1.useInjection)("blockStore");
    var colorProvider = (0, FilterableColorProvider_1.useFilterableColorProvider)();
    if ((0, EditorWidgetRegistry_1.isContainerManagedWidget)(element.type)) {
        return undefined;
    }
    var styleableConfig = (0, GetTraitConfig_1.getTraitConfig)({ widgetType: element.type, traitName: "styleable" });
    if (styleableConfig) {
        var blockStyle = (_a = blockStore.blockStyleStore.model[styleableConfig.styleKey]) !== null && _a !== void 0 ? _a : null;
        var overrides = "style" in element ? element.style : null;
        var rawStyleObject = (0, widgetStyle_1.widgetStyle)({
            blockStyle: blockStyle,
            colorProvider: colorProvider,
            overrides: overrides,
            styleableConfig: styleableConfig,
            paragraphBlockStyle: blockStore.blockStyleStore.getElementStyle("p"),
            heading2BlockStyle: blockStore.blockStyleStore.getElementStyle("h2"),
        });
        return styleToVEVars(rawStyleObject, styleableConfig);
    }
};
exports.useStyleableAttributes = useStyleableAttributes;
var useWidgetStyleProps = function (element) {
    var _a;
    var blockStore = (0, inversify_react_1.useInjection)("blockStore");
    var colorProvider = (0, FilterableColorProvider_1.useFilterableColorProvider)();
    if ((0, EditorWidgetRegistry_1.isContainerManagedWidget)(element.type)) {
        return undefined;
    }
    var styleableConfig = (0, GetTraitConfig_1.getTraitConfig)({ widgetType: element.type, traitName: "styleable" });
    if (!styleableConfig) {
        return {};
    }
    var blockStyle = (_a = blockStore.blockStyleStore.model[styleableConfig.styleKey]) !== null && _a !== void 0 ? _a : null;
    var overrides = "style" in element ? element.style : null;
    return (0, widgetStyle_1.widgetStyle)({
        blockStyle: blockStyle,
        colorProvider: colorProvider,
        overrides: overrides,
        styleableConfig: styleableConfig,
        paragraphBlockStyle: blockStore.blockStyleStore.getElementStyle("p"),
        heading2BlockStyle: blockStore.blockStyleStore.getElementStyle("h2"),
    });
};
var useSpacingShimClassName = function (element) {
    if ((0, EditorWidgetRegistry_1.isContainerManagedWidget)(element.type)) {
        return undefined;
    }
    var config = (0, GetTraitConfig_1.getTraitConfig)({ widgetType: element.type, traitName: "spacingShim" });
    return config === null || config === void 0 ? void 0 : config.className;
};
var useAlignableAttributes = function (element) {
    if ((0, EditorWidgetRegistry_1.isAlignableWidget)(element)) {
        if (element.data.alignment === "left") {
            return {
                style: {
                    justifyContent: "flex-start",
                },
            };
        }
        else {
            return {
                style: {
                    justifyContent: "center",
                },
            };
        }
    }
};
exports.RegistryElement = (0, mobx_react_1.observer)(function (_a) {
    var properties = _a.properties;
    var attributes = properties.attributes, element = properties.element, children = properties.children;
    var _b = __read((0, react_1.useState)(null), 2), selectorElement = _b[0], setSelectorElement = _b[1];
    var editorStatic = (0, slate_react_1.useSlateStatic)();
    var configuration = (0, EditorWidgetRegistry_1.getGenericConfigByType)(element.type, true);
    var usingFeature = (0, inversify_react_1.useInjection)("usingFeature");
    var allowWidgetDragAndDrop = (0, DragContext_1.useDragContext)().allowWidgetDragAndDrop;
    (0, tiny_invariant_1.default)(!!configuration, "RegistryElement can't be used to render non-registry type");
    var styleableAttributes = (0, exports.useStyleableAttributes)(element);
    var alignableAttributes = useAlignableAttributes(element);
    var widgetAttributes = {
        className: (0, classnames_1.default)({
            "project-block__block-element": slate_1.Editor.isBlock(editorStatic, element) &&
                !(0, EditorWidgetRegistry_1.isContainerManagedWidget)(element.type) &&
                !(0, HasTrait_1.hasTrait)({
                    widgetType: element.type,
                    traitName: "skipContainerAnimation",
                }),
        }),
    };
    var componentStyle = useWidgetStyleProps(element);
    var spacingShimClassName = useSpacingShimClassName(element);
    if (configuration === null || configuration === void 0 ? void 0 : configuration.selfManagedRender) {
        return (react_1.default.createElement(MaybeWrap_1.default, { wrapper: function (children) {
                if (configuration === null || configuration === void 0 ? void 0 : configuration.widgetContextProvider) {
                    return (react_1.default.createElement(configuration.widgetContextProvider, { element: element }, children));
                }
                return children;
            } },
            react_1.default.createElement(configuration.editorRender, { attributes: attributes, element: element, children: children })));
    }
    if ((0, EditorWidgetRegistry_1.isInlineWidget)(element)) {
        return (react_1.default.createElement(SelectionRing_1.SelectionRing, { ref: function (el) {
                setSelectorElement(el);
            }, element: element },
            react_1.default.createElement(WidgetToolbar_1.WidgetToolbar, { element: element, anchorElement: selectorElement }),
            react_1.default.createElement(configuration.editorRender, { attributes: widgetAttributes, element: element, style: componentStyle }, children)));
    }
    return (react_1.default.createElement(Resizer_1.ResizerProvider, { mountNode: selectorElement, element: element }, function (resizingContext) { return (react_1.default.createElement("div", __assign({}, attributes, { className: (0, classnames_1.default)(styles.registryElementWrapper({
            resizingEnabled: resizingContext.resizingEnabled,
        }), spacingShimClassName), style: __assign(__assign({}, alignableAttributes === null || alignableAttributes === void 0 ? void 0 : alignableAttributes.style), styleableAttributes === null || styleableAttributes === void 0 ? void 0 : styleableAttributes.style) }),
        react_1.default.createElement("div", { "data-width-constraining-div": true, className: styles.widthConstrainingDiv({ width: configuration === null || configuration === void 0 ? void 0 : configuration.width }), style: __assign({}, (resizingContext.resizingEnabled ? resizingContext.styles.widthConstrainingElement : {})) },
            react_1.default.createElement(MaybeWrap_1.default, { wrapper: function (children) {
                    if (configuration === null || configuration === void 0 ? void 0 : configuration.widgetContextProvider) {
                        return (react_1.default.createElement(configuration.widgetContextProvider, { element: element }, children));
                    }
                    return null;
                } },
                react_1.default.createElement(MaybeWrap_1.default, { wrapper: function (children) {
                        if ((0, EditorWidgetRegistry_1.isContainerManagedWidget)(element.type) ||
                            ((configuration === null || configuration === void 0 ? void 0 : configuration.nodeType) === "textElement" &&
                                !(usingFeature(FeatureFlag_1.default.ErgonomicsDragging) && allowWidgetDragAndDrop))) {
                            return null;
                        }
                        return (react_1.default.createElement(SelectionRing_1.SelectionRing, { ref: function (el) {
                                setSelectorElement(el);
                            }, element: element },
                            react_1.default.createElement(WidgetToolbar_1.WidgetToolbar, { element: element, anchorElement: selectorElement }),
                            children));
                    } },
                    react_1.default.createElement(MaybeWrap_1.default, { wrapper: function (children) {
                            var _a;
                            var allowDragAndDropChildren = (_a = configuration.containerNodeConfiguration) === null || _a === void 0 ? void 0 : _a.allowDragAndDropChildren;
                            if (allowDragAndDropChildren != null) {
                                return (react_1.default.createElement(DragContext_1.DragProvider, { value: { allowWidgetDragAndDrop: allowDragAndDropChildren } }, children));
                            }
                            return null;
                        } },
                        react_1.default.createElement("div", { "data-element-type": configuration.nodeType, "data-layout-node": !!(configuration === null || configuration === void 0 ? void 0 : configuration.containerNodeConfiguration), className: styles.widgetWrapper },
                            react_1.default.createElement(configuration.editorRender, { attributes: widgetAttributes, element: element, style: componentStyle }, children)))))),
        resizingContext.resizingEnabled && react_1.default.createElement(Resizer_1.SnapAreas, null))); }));
});
